// Biuro rady — kontrakty modułu sesji rady i porządku obrad.
// Port modułu CouncilSessionAgenda z Magistratu; wartości enumów są 1:1 z
// Kwantum.Enums (CouncilSessionState, CouncilSessionAgendaItemType, VotingType, VotingResult),
// więc nie wolno ich przenumerowywać.

export enum ECouncilSessionState {
  NotStarted = 0,
  InProgress = 1,
  Suspended = 2,
  Finished = 3,
  Closed = 4,
  PresenceCheck = 5,
}

export enum ECouncilAgendaItemType {
  /** Zwykły punkt porządku obrad. */
  Description = 0,
  /** Załącznik jako pozycja drzewa — w Nota załączniki mają własną kolekcję, typ zostaje dla zgodności. */
  Attachment = 1,
  /** Punkt statyczny „Przedstawienie porządku obrad" — nie może mieć podrzędnych. */
  StaticApproveAgenda = 2,
}

export enum ECouncilVotingType {
  None = 0,
  Normal = 1,
  AbsoluteVer1 = 2,
  Custom = 3,
  AbsoluteVer2 = 4,
  AbsoluteFull = 5,
  Qualified = 6,
}

export enum ECouncilVotingResult {
  Unset = 0,
  Positive = 1,
  Negative = 2,
  Skip = 3,
  WithoutVote = 4,
  Canceled = 99,
}

export interface ICouncilSession {
  Id: string;
  Number: string | null;
  Title: string | null;
  Date: string | null;
  State: ECouncilSessionState;
  StartDate: string | null;
  FinishDate: string | null;
  SuspendedDate: string | null;
  /** Opublikowana — widoczna w portalu radnego (jedna na profil). */
  IsActive: boolean;
  /** Sesja była kiedykolwiek opublikowana — to ona, a nie IsActive, otwiera publiczny dostep. */
  WasPublished: boolean;
  IsArchived: boolean;
  IsOnline: boolean;
  VideoUrl: string | null;
  /**
   * Radny prowadzący obrady. Decyduje o odmianie zdań protokołu
   * („Przewodniczący zarządził…" / „Przewodnicząca zarządziła…").
   */
  LeadByCouncilorId: string | null;
  IsSigned: boolean;
  IsProtocolSigned: boolean;
  IsProtocolPublished: boolean;
  /** Nazwa wgranego pliku protokolu (etap 2). */
  ProtocolFileName: string | null;
  /** Czy do sesji podpieto plik protokolu. */
  HasProtocol: boolean;
  CaseId: string | null;
  CreationDate: string;
  AgendaItemsCount: number;
}

export interface ISaveCouncilSessionRequest {
  Id?: string | null;
  Number: string;
  Title?: string | null;
  Date: string | null;
  IsOnline: boolean;
  VideoUrl?: string | null;
  LeadByCouncilorId?: string | null;
  CaseId?: string | null;
}

export interface ICouncilAgendaAttachment {
  Id: string;
  AgendaItemId: string;
  Title: string | null;
  FileName: string | null;
  ContentType: string | null;
  Size: number;
  FileUri: string | null;
  SortOrder: number;

  /**
   * Akt prawa miejscowego dołączony ZAMIAST pliku — w Magistracie rolę tę pełniło
   * pole AgendaItem.DocumentId. Gdy ustawione, pola pliku są puste, a nazwę niesie
   * tytuł aktu i jego numer.
   */
  LegalActId?: string | null;
  ActNumber?: string | null;
  ActTypeName?: string | null;
}

/** Projekt aktu możliwy do dołączenia do punktu porządku obrad. */
export interface ICouncilLegalActOption {
  Id: string;
  ActNumber: string | null;
  Title: string | null;
  ActTypeName: string;
  Date: string | null;
  Status: number;
}

/**
 * Punkt porządku obrad. Lista jest płaska — hierarchię niesie ParentId,
 * a numerację Order („1", „1.2", „1.2.3"), tak jak w Magistracie.
 */
export interface ICouncilAgendaItem {
  Id: string;
  ParentId: string | null;
  Order: string | null;
  Type: ECouncilAgendaItemType;
  Title: string | null;
  Description: string | null;
  IsActive: boolean;
  VotingType: ECouncilVotingType;
  VotingResult: ECouncilVotingResult;
  /** Punkt ma powiązane zdarzenia protokołu/głosowania — nie wolno go usunąć (etap 2). */
  HasActions: boolean;
  HasVotings: boolean;
  Attachments: ICouncilAgendaAttachment[];
}

export interface ISaveCouncilAgendaRequest {
  Items: ICouncilAgendaItem[];
}

export interface ISaveCouncilAgendaResponse {
  /** Mapowanie Id tymczasowego (z klienta) → Id nadane przez serwer. */
  NewItems: Record<string, string>;
  Items: ICouncilAgendaItem[];
}

export interface ICouncilGuest {
  Id: string;
  FirstName: string | null;
  LastName: string | null;
  Role: string | null;
  Male: boolean;
  ClientId: string | null;
  SortOrder: number;
}

export interface ISaveCouncilGuestRequest {
  Id?: string | null;
  FirstName?: string | null;
  LastName?: string | null;
  Role?: string | null;
  Male: boolean;
  ClientId?: string | null;
}

export interface ICouncilAttachmentDownload {
  Id: string;
  FileName: string | null;
  ContentType: string | null;
  Size: number;
  Url: string | null;
}

export interface ICouncilArchiveYear {
  Year: number;
  SessionsCount: number;
}
